import CoinHeader from "Components/Coin/CoinHeader/CoinHeader";
import EarningJourney from "Components/Coin/EarningJourney/EarningJourney";
import EarnMVRSection from "Components/Coin/EarnMVRSection/EarnMVRSection";
import ExpectedROI from "Components/Coin/ExpectedROI/ExpectedROI";
import FAQs from "Components/Coin/FAQs/FAQs";
import MeetUsCoinsSection from "Components/Coin/MeetUsCoinsSection/MeetUsCoinsSection";
import MVRCoinsJourney from "Components/Coin/MVRCoinsJourney/MVRCoinsJourney";
import MVRStakingSection from "Components/Coin/MVRStakingSection/MVRStakingSection";
import StakingGuide from "Components/Coin/StakingGuide/StakingGuide";
import SEO from "Components/SEO";
import WorldOfMetaverse from "Components/WorldOfMetaverse";
import React from "react";

const Coin = () => {
    return (
        <div>
            <SEO />
            <CoinHeader />
            <WorldOfMetaverse />
            <MeetUsCoinsSection />
            <MVRStakingSection />
            <EarningJourney />
            <StakingGuide />
            <WorldOfMetaverse />
            <MVRCoinsJourney />
            <FAQs />
            <EarnMVRSection />
            <ExpectedROI />
        </div>
    );
};

export default Coin;
